import React from "react";
import { Image, Row, Col } from "react-bootstrap";
import ProductStateInformation from "shared/components/ProductStateInformation";
import Pricing from "shared/components/Pricing";
import Favorite from "shared/components/Favorite";
import { EanNumber, LineBreaksParagraph } from "shared/components";
import { account } from "shared/storeInfo";
import { wrapArray } from "shared/utils/support";
import DeliveryAreaWarning from "../DeliveryAreaWarning";
import ProductAlert from "../ProductAlert";
import ProductImageCarousel from "../ProductImageCarousel";
import SalesFiguresPane from "../SalesFiguresPane";
import ProductAlternatives from "../ProductAlternatives";
import BasePrice from "../BasePrice";

const ProductImageArea = props => {
  const { product, favorites, setProductWithNewFavorites } = props;
  return (
    <div>
      <Row>
        <Col xs={6}>
          <ProductStateInformation product={product} />
        </Col>
        <Col xs={6}>
          <Favorite
            isFavorite={
              !!favorites.find(
                favorite => favorite.merchantAccountId === account("id"),
              )
            }
            favoriteCount={favorites.length}
            product={product}
            // REFACTOR: It could be that this is unneeded
            setProductWithNewFavorites={setProductWithNewFavorites}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <ProductImageCarousel product={product} />
        </Col>
      </Row>
    </div>
  );
};

const ProductDetailsPane = props => {
  const { product, variants, availableActions, productChartsUrl, isMerchant } =
    props;
  return (
    <div className="productDetailsPanel">
      <h3>{product.productVariantName}</h3>
      <hr />
      <Pricing product={product} />
      <hr />
      <SalesFiguresPane
        productChartsUrl={productChartsUrl}
        product={product}
        favoritesCount={product.favoritesCount}
        isMerchant={isMerchant}
      />
      <hr />
      <ProductAlternatives variants={variants} />
      {availableActions}
    </div>
  );
};

const OrderInformationPane = props => {
  const { product, isMerchant, npiProductPassportUrl, startup } = props;

  return (
    <div>
      <h4>Bestellinformationen</h4>
      <div className="productDetailList">
        {isMerchant && (
          <a href={npiProductPassportUrl}>Alle Artikelstammdaten anzeigen</a>
        )}
        <br />
        {startup.edekaSupplierId && (
          <div>
            <strong>ZKS-Nummer Startup: </strong> {startup.edekaSupplierId}{" "}
            <br />
          </div>
        )}
        {startup.lineSupplier && (
          <div>
            <strong>ZKS-Nummer EDEKA StartHub: </strong> 5292282
            <br />
          </div>
        )}
        {product.edmNumber && (
          <div>
            <strong>EDM-Nummer: </strong> {product.edmNumber} <br />
          </div>
        )}
        <strong>EAN: </strong>
        <EanNumber ean={product.ean} />
        <br />
        <strong>Lieferant Art.-Nr.:</strong> {product.supplierArticleNumber}
        <br />
        <strong>Grundpreis:</strong> <BasePrice product={product} />
        <br />
        <strong>Bestelleinheit: </strong>
        {product.shippingUnitProductCount &&
          product.packaging &&
          product.salesUnitQuantity &&
          product.salesUnitType && (
            <span>
              {product.shippingUnitProductCount} ({product.packaging} à{" "}
              {product.salesUnitQuantity} {product.salesUnitType})
            </span>
          )}
        {!startup.productWizard &&
          product.sampleOrderContent !== undefined &&
          product.sampleOrderContent !== "" && (
            <div>
              <strong>Ungefährer Inhalt der Probebestellung:</strong>{" "}
              {product.sampleOrderContent}
            </div>
          )}
      </div>
      <hr />
    </div>
  );
};

const ContactPane = props => {
  const { startup } = props;
  const startupLogoUrl = startup.logo ? startup.logo.thumbnail : "";

  return (
    <div>
      <h4>Ansprechpartner</h4>
      <Row>
        <Col xs={6}>
          <div>{startup.contactName}</div>
          <div>{startup.contactJob}</div>
          <div>
            <a href={startup.website}>{startup.website}</a>
          </div>
        </Col>
        <Col xs={6}>
          {startupLogoUrl !== undefined && (
            <div
              style={{ backgroundImage: `url(${startupLogoUrl})` }}
              className="productLogo"
            />
          )}
        </Col>
      </Row>
    </div>
  );
};

const ProductAndTeamPane = props => {
  const { product, startup } = props;

  return (
    <div>
      <h4>Über das Produkt</h4>
      <LineBreaksParagraph>{product.usp}</LineBreaksParagraph>
      {!startup.productWizard &&
        <>
        <h4>Wertversprechen</h4>
        <ul className="usp">
          {product.valueProposition.map((valueProposition, i) => (
            <li key={i}>{valueProposition}</li>
          ))}
        </ul>
        </>
      }
      <h4>Das Team</h4>
      <LineBreaksParagraph>{startup.companyBackground}</LineBreaksParagraph>
      <br />

      {(startup.teamImage !== undefined ||
        (startup.teamBackground !== undefined &&
          startup.teamBackground !== "")) && (
        <div>
          {startup.teamImage && (
            <Row>
              <Col xs={12}>
                <br />
                <Image src={startup.teamImage.high} responsive rounded />
                <br />
              </Col>
            </Row>
          )}

          {startup.teamBackground && startup.teamBackground !== "" && (
            <Row>
              <Col xs={12}>
                <LineBreaksParagraph>
                  {startup.teamBackground}
                </LineBreaksParagraph>
              </Col>
            </Row>
          )}
        </div>
      )}

      <span className="visible-xs-block">
        <hr />
      </span>
    </div>
  );
};

function ProductDetails(props) {
  const { product } = props;
  const { startup } = props.product;
  const variants = wrapArray(props.product.publishedVariants || []);
  const favorites = wrapArray(props.product.favorites || []);

  return (
    <Row>
      <Col lg={10} lgOffset={1} md={12}>
        <Row>
          <DeliveryAreaWarning deliveryArea={startup.deliveryArea} />
          <ProductAlert productAlert={product.alert} />
        </Row>
        <Row>
          {/* left column */}
          <Col xs={12} md={8}>
            <Row>
              <Col xs={12}>
                <ProductImageArea
                  product={product}
                  favorites={favorites}
                  setProductWithNewFavorites={props.setProductWithNewFavorites}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} xsHidden smHidden>
                <ProductAndTeamPane startup={startup} product={product} />
              </Col>
            </Row>
          </Col>
          {/* right column */}
          <Col xs={12} md={4}>
            <Row>
              <Col xs={12}>
                <ProductDetailsPane
                  product={product}
                  variants={variants}
                  availableActions={props.availableActions}
                  productChartsUrl={props.productChartsUrl}
                  isMerchant={props.isMerchant}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <OrderInformationPane
                  product={product}
                  isMerchant={props.isMerchant}
                  npiProductPassportUrl={props.npiProductPassportUrl}
                  startup={startup}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <ContactPane startup={startup} />
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col md={12} mdHidden lgHidden>
            <ProductAndTeamPane startup={startup} product={product} />
          </Col>
        </Row>
        <br />
        <br />
        <br />
      </Col>
    </Row>
  );
}

export default ProductDetails;
